import {
  ASSIGNMENT_STATUS,
  ISG_REPORT_VIEW_OPTIONS,
  ISG_TREND_COMPONENT_TYPES,
} from '../../../../../utils/constants';
import { getStudentRowData } from '../../../../InstructorGradebookContainer/Components/GridCell/GridCellDataHelpers';
import {
  getRoundPercentTypeValue,
  getScoreChangeFromPrevious,
  isUncompletePastDueAssignment,
  formatISGPoints,
  hasFirstDueDatePassed,
} from '../../utils';
import { TrendChip } from './TrendChip';
import { PrimaryMetricsLayout } from '../shared/PrimaryMetricsLayout';
import { getConfigObject } from '../../../../../utils/config';
import s from './PrimaryMetrics.module.css';
import sharedStyles from '../shared/PrimaryMetricsLayout.module.css';

export const PrimaryMetrics = ({
  currentView,
  isAccordionOpen,
  total,
  assignments,
  isMobile,
  isUngraded,
  settings,
  previousSectionData,
  user,
}) => {
  const numCompleted =
    assignments.filter(
      (assignment) =>
        assignment.status.toLowerCase() ===
        ASSIGNMENT_STATUS.COMPLETED.toLowerCase(),
    ).length || 0;

  const outOfAssignments = assignments.length || 0;
  const numUncompletedPastDue =
    assignments.filter(isUncompletePastDueAssignment).length || 0;

  const hasFirstDueDatePassedForAssignments =
    hasFirstDueDatePassed(assignments);

  const { studentPoints, assignedPoints } = formatISGPoints(
    total?.studentPoints || 0,
    total?.assignedPoints || 0,
  );

  const showPercentSetting = settings.find(
    (setting) => setting.key === 'showPercent',
  )?.value;
  const isShowPercent = showPercentSetting !== 'false';

  const scoreDataPercent = getStudentRowData({
    cellData: total,
    showPercent: true,
    roundPercentType: getRoundPercentTypeValue(settings),
    isgCurrentView: currentView,
    user,
    displayClass: isShowPercent ? s.total : s.totalSecondary,
  });

  let totalLabel = '';
  if (currentView === ISG_REPORT_VIEW_OPTIONS.CATEGORY) {
    totalLabel = 'category total';
  } else if (currentView === ISG_REPORT_VIEW_OPTIONS.WEEK) {
    totalLabel = 'week total';
  } else {
    totalLabel = 'unit total';
  }

  const scoreDataPointsLabel = `${studentPoints}/${assignedPoints} pts`;
  const scoreDataPercentageLabel = scoreDataPercent.content;

  const primaryTotal = isShowPercent
    ? scoreDataPercentageLabel
    : scoreDataPointsLabel;
  const secondaryTotal = isShowPercent
    ? scoreDataPointsLabel
    : scoreDataPercentageLabel;

  let scoreChangeFromPrevious = null;
  let shouldShowTrendChip = false;
  const { FF_ISR_SLICE_2 } = getConfigObject();

  if (FF_ISR_SLICE_2 && !isMobile) {
    shouldShowTrendChip = true;
    scoreChangeFromPrevious = getScoreChangeFromPrevious(
      total,
      previousSectionData?.total,
    );
  }

  const scoreMetricContent = (
    <>
      <span className={s.primary}>{primaryTotal} </span>
      <span className={s.secondary}>
        {'('}
        {secondaryTotal}
        {')'}
      </span>
      <div className={s.totalLabel}>{totalLabel}</div>
      {shouldShowTrendChip && scoreChangeFromPrevious && (
        <TrendChip
          value={scoreChangeFromPrevious}
          type={ISG_TREND_COMPONENT_TYPES.SCORE}
          currentView={currentView}
        />
      )}
    </>
  );

  const activitiesMetricContent = (
    <>
      <span className={s.primary}>
        {numCompleted} / {outOfAssignments}
      </span>
      <div className={s.totalLabel}>activities completed</div>
      {shouldShowTrendChip && hasFirstDueDatePassedForAssignments && (
        <TrendChip
          value={numUncompletedPastDue}
          type={ISG_TREND_COMPONENT_TYPES.UNCOMPLETED_ACTIVITIES}
          currentView={currentView}
        />
      )}
    </>
  );

  const dividerHeightClass = FF_ISR_SLICE_2
    ? sharedStyles.dividerSlice2
    : sharedStyles.dividerSlice1;

  return (
    <PrimaryMetricsLayout
      isAccordionOpen={isAccordionOpen}
      scoreMetricContent={scoreMetricContent}
      activitiesMetricContent={activitiesMetricContent}
      showDivider={!isUngraded}
      dividerHeightClass={dividerHeightClass}
      isUngraded={isUngraded}
    />
  );
};
